import Flickity from "flickity";

function InitializeCopyGridSliders(){
    document.querySelectorAll('.copy-grid.as-slider').forEach((el)=>{
        new Flickity(el,{
            // selector needs to pick the elements while both not in flickity and while in flickity.
            cellSelector:':is(.copy-grid, .flickity-slider) >:not(.headline-area)',
            watchCSS:true,
            adaptiveHeight: false,
            pageDots:false,
            cellAlign: 'left',
            prevNextButtons: false
        })
    })

}

export {InitializeCopyGridSliders};